<template>
  <!-- 新建提货指令 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%" v-if="editable"></div>
    <div class="topBtns" v-if="editable">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
        >保存</el-button
      >
      <!-- <el-button style="margin-top: 10px" class="glo_bg" @click="saveConfirm('baseInFormRef')">取消</el-button> -->
      <span v-if="isSee == '100'">
        <el-button style="margin-top: 10px" class="glo_bg" @click="saveClick(1)"
          >新增</el-button
        >
        <el-button style="margin-top: 10px" class="glo_bg" @click="saveClick(2)"
          >修改</el-button
        >
        <el-button style="margin-top: 10px" class="glo_bg" @click="saveClick(3)"
          >复制新增</el-button
        >
      </span>
    </div>
    <div class="form_head" v-loading="loadingDetail">
      <div class="waybill_Type">{{ waybillStatus }}</div>
      <el-form
        label-width="100px"
        class="head_formBox glo_formBox"
        ref="form1"
        :model="commandInfo"
        :rules="rule1"
      >
        <el-form-item label="指令编号:">
          <el-input
            :disabled="disabledSee"
            v-model="commandInfo.commandNumber"
            placeholder="不录入则自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="运单号:">
          <el-input
            :disabled="disabledSee"
            v-model="commandInfo.waybillNumber"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="中转单号:">
          <el-input
            :disabled="disabledSee"
            v-model="commandInfo.transferNumber"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="客户单号:">
          <el-input
            :disabled="disabledSee"
            v-model="commandInfo.customerOrderNumber"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="接单网点:" required prop="receiveOrderDeptId">
          <!-- <el-select
            :disabled="disabledSee"
            filterable
            clearable
            v-model="commandInfo.receiveOrderDeptId"
            placeholder="请选择"
          >
            <el-option
              v-for="dept in businessDepts"
              :key="dept.deptId"
              :label="dept.deptName"
              :value="dept.deptId"
            ></el-option>
          </el-select> -->
          <dept-tree
            v-model="commandInfo.receiveOrderDeptId"
            :disabled="disabledSee"
            :multiple="false"
            :checkStrictly="true"
            :is-storage="1"
          ></dept-tree>
        </el-form-item>
      </el-form>
    </div>
    <div class="all_div" v-loading="loadingDetail">
      <!-- 基本信息 -->
      <div class="infoDiv">
        <div class="h3title">基础信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form2"
            :rules="rule2"
            :model="commandInfo"
          >
            <el-form-item label="目的城市:" prop="destCity">
              <el-select
                clearable
                placeholder="请输入并选择"
                filterable
                remote
                v-model="commandInfo.destCity"
                :remote-method="getDestCities"
                :loading="destCityLoading"
                @change="changeDestCity"
                @clear="clearDestCity"
                :disabled="disabledSee"
              >
                <el-option
                  v-for="(city, index) in destCitys"
                  :key="index"
                  :label="city.destCity"
                  :value="city.cityName"
                >
                  <span style="float: left">{{ city.destCity }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    city.adCode
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运输路线:" prop="transportLineId">
              <el-select
                clearable
                placeholder="请输入并选择"
                filterable
                remote
                v-model="commandInfo.transportLineId"
                :loading="transportLineLoading"
                @change="changeTransportLine"
                :disabled="disabledSee"
              >
                <el-option
                  v-for="line in lines"
                  :key="line.id"
                  :label="line.lineName"
                  :value="line.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="终端网点:" prop="endDeptId">
              <!-- <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="commandInfo.endDeptId"
                placeholder="请选择"
                @change="changeEndDept"
              >
                <el-option
                  v-for="dept in businessDepts"
                  :key="dept.deptId"
                  :label="dept.deptName"
                  :value="dept.deptId"
                ></el-option>
              </el-select> -->
              <dept-tree
                v-model="commandInfo.endDeptId"
                :disabled="disabledSee"
                :multiple="false"
                :checkStrictly="true"
                :is-storage="1"
                iNeedAll
                @change="changeEndDept"
              ></dept-tree>
            </el-form-item>
            <el-form-item label="发货方式:" prop="receiveMethodConfDictId">
              <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="commandInfo.receiveMethodConfDictId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in receMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运输方式:" prop="transportMethodConfDictId">
              <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="commandInfo.transportMethodConfDictId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in transportMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="交货方式:" prop="sendMethodConfDictId">
              <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="commandInfo.sendMethodConfDictId"
                placeholder="请选择"
                @change="changeSendMethod"
              >
                <el-option
                  v-for="item in sendMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="回单要求:" prop="rnRequireCount">
              <div class="glo_disFlex" style="padding-right: 3px">
                <el-select
                  style="flex"
                  v-model="commandInfo.rnRequireConfDictId"
                  placeholder="请选择"
                  filterable
                  clearable
                  @change="changeRnRquireConf"
                  :disabled="disabledSee"
                >
                  <el-option
                    v-for="item in rnRequirements"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-input
                  class="miniInput"
                  v-model="commandInfo.rnRequireCount"
                  placeholder="份数"
                  type="number"
                  @mousewheel.native.prevent
                  :disabled="disabledSee"
                ></el-input
                >份
              </div>
            </el-form-item>
            <el-form-item label="开单网点:" prop="openOrderDeptId">
              <!-- <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="commandInfo.endDeptId"
                placeholder="请选择"
                @change="changeEndDept"
              >
                <el-option
                  v-for="dept in businessDepts"
                  :key="dept.deptId"
                  :label="dept.deptName"
                  :value="dept.deptId"
                ></el-option>
              </el-select> -->
              <dept-tree
                v-model="commandInfo.openOrderDeptId"
                :disabled="disabledSee"
                :multiple="false"
                :checkStrictly="true"
                :is-storage="1"
                @change="changeOpenDept"
              ></dept-tree>
            </el-form-item>
            <el-form-item class="textArea" style="width: 100%" label="备注:">
              <el-input
                :disabled="disabledSee"
                placeholder="请输入"
                clearable
                v-model="commandInfo.remarks"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 收发信息 -->
      <div class="infoDiv">
        <div class="h3title">收发信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form7"
            :model="commandInfo"
            :rules="rule7"
          >
            <el-form-item label="客户类型:" prop="customerType">
              <el-radio-group
                :disabled="disabledSee"
                v-model="commandInfo.customerType"
                @change="changeCustomerType"
              >
                <el-radio :label="0">散客</el-radio>
                <el-radio :label="1">常客</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="开单客户:"
              :required="commandInfo.customerType == 1"
              v-show="commandInfo.customerType == 1"
              prop="customerId"
            >
              <el-select
                :disabled="disabledSee"
                clearable
                filterable
                remote
                allow-create
                :remote-method="remoteMethodCustomer"
                default-first-option
                v-model="commandInfo.customerId"
                placeholder="请选择"
                @change="changeMethodCustomer"
                @focus="focusMethodCustomer"
              >
                <el-option
                  v-for="(item, index) in CustomerLists"
                  :key="index"
                  :label="
                    (item.phone || '') +
                    ' / ' +
                    (item.customerNumber || '') +
                    ' / ' +
                    item.customerName
                  "
                  :value="item.customerId"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="Divider"></div>
          </el-form>
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form3"
            :model="sendAddr"
          >
            <el-form-item label="发货单位:">
              <el-input
                :disabled="disabledSee"
                v-model="sendAddr.company"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="发货人:">
              <el-input
                :disabled="disabledSee"
                v-model="sendAddr.contacts"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="联系电话:">
              <el-input
                :disabled="disabledSee"
                v-model="sendAddr.tel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号码:">
              <el-input
                :disabled="disabledSee"
                v-model="sendAddr.idNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%; border: 0" label="发货地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="sendAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="sendAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity"
                  @focus="getCityName(sendAddr.provinceName)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="sendAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(sendAddr.cityName)"
                  @change="changeArea"
                >
                  <el-option
                    v-for="(item, index) in areaNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee"
                  class="selectAddress addressDetails"
                  v-model="sendAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(sendAddr.address)"
                ></el-input>
                <i
                  v-if="editable"
                  class="el-icon-full-screen"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #409eff;
                    font-weight: bold;
                  "
                  @click="go2AddressAI(1)"
                ></i>
                <i
                  v-if="editable"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(1)"
                ></i>
                <i
                  v-if="editable"
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    color: #7f7f7f;
                    font-weight: bold;
                  "
                  @click="changeRecAddress(1)"
                ></i>
                <div class="checkBox">
                  <el-checkbox :disabled="disabledSee" v-model="isAutoAddr_jj"
                    >收录发货地址</el-checkbox
                  >
                </div>
              </div>
            </el-form-item>
            <div class="Divider"></div>
            <el-form-item label="收货单位:">
              <el-input
                :disabled="disabledSee"
                v-model="receiveAddr.company"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人:">
              <el-input
                :disabled="disabledSee"
                v-model="receiveAddr.contacts"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="联系电话:">
              <el-input
                :disabled="disabledSee"
                v-model="receiveAddr.tel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号码:">
              <el-input
                :disabled="disabledSee"
                v-model="receiveAddr.idNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%; border: 0" label="收货地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="receiveAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince(1)"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="receiveAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity(1)"
                  @focus="getCityName(receiveAddr.provinceName, 1)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="receiveAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(receiveAddr.cityName, 1)"
                  @change="changeArea"
                >
                  <el-option
                    v-for="(item, index) in areaNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee"
                  class="selectAddress addressDetails"
                  v-model="receiveAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(receiveAddr.address)"
                ></el-input>
                <i
                  v-if="editable"
                  class="el-icon-full-screen"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #409eff;
                    font-weight: bold;
                  "
                  @click="go2AddressAI(2)"
                ></i>
                <i
                  v-if="editable"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(2)"
                ></i>
                <i
                  v-if="editable"
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    color: #7f7f7f;
                    font-weight: bold;
                  "
                  @click="changeRecAddress(2)"
                ></i>
                <div class="checkBox">
                  <el-checkbox :disabled="disabledSee" v-model="isAutoAddr_sj"
                    >收录收货人信息</el-checkbox
                  >
                </div>
              </div>
            </el-form-item>
            <div class="Divider"></div>
            <el-form-item label="自提电话:">
              <el-input
                :disabled="disabledSee"
                v-model="takeAddr.tel"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item style="flex: 1; border: 0" label="自提地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="takeAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince(2)"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="takeAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity(2)"
                  @focus="getCityName(takeAddr.provinceName, 2)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList_2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="takeAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(takeAddr.cityName, 2)"
                  @change="changeArea"
                >
                  <el-option
                    v-for="(item, index) in areaNameList_2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee"
                  class="selectAddress addressDetails"
                  v-model="takeAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(takeAddr.address)"
                ></el-input>
                <i
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(3)"
                ></i>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 货物信息 -->
      <div class="infoDiv" id="tables">
        <div class="h3title">货物信息</div>
        <div class="formbox goodsItmes">
          <div class="glo_Table goodsTable">
            <el-table
              :data="sendAddrs_1"
              border
              show-summary
              ref="mytable1"
              :summary-method="getSummaries"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column prop="goodsNumber" label="货物编号">
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    type="text"
                    v-model="sendAddrs_1[scope.$index].goodsNumber"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="itemCategoryName"
                label="品名"
              >
                <template slot-scope="scope">
                  <el-select
                    :disabled="disabledSee"
                    clearable
                    filterable
                    remote
                    allow-create
                    default-first-option
                    placeholder="请选择"
                    v-model="sendAddrs_1[scope.$index].itemCategoryName"
                    :remote-method="
                      (e) => {
                        remoteMethodCategory(e, scope.$index);
                      }
                    "
                    @change="
                      (e) => {
                        changeMethodCategory(e, scope.$index);
                      }
                    "
                    @focus="focusMethodCategory(scope.$index)"
                    @clear="remoteMethodCategory('', scope.$index)"
                  >
                    <el-option
                      v-for="(item2, index2c) in goodsList"
                      :key="index2c"
                      :label="item2.itemName"
                      :value="item2.itemName"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="packageName" label="包装">
                <template slot-scope="scope">
                  <el-select
                    @change="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    v-model="sendAddrs_1[scope.$index].packageName"
                    filterable
                    allow-create
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item2, index2c) in packageNameList"
                      :key="index2c"
                      :label="item2.val"
                      :value="item2.val"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="packageCout" label="*件数" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].packageCout"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="grossWeight" label="*毛重" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].grossWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="netWeight" label="净重" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].netWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volume"
                label="*体积/m³"
                sortable
                width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    @change="calcVolumeWeight(scope.$index)"
                    :disabled="disabledSee"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volume"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volumeDivisor"
                label="*体积系数"
                sortable
                width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    @change="calcVolumeWeight(scope.$index)"
                    :disabled="disabledSee"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volumeDivisor"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volumeWeight"
                label="体积重量/KG"
                sortable
                width="120"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volumeWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="billingWeight"
                label="计费重量"
                sortable
                width="120"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].billingWeight"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="specs" label="规格">
                <template slot-scope="scope">
                  <div class="linkTabel" @click="clickSet(scope.$index)">
                    规格
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="packageName" label="重/泡货">
                <template slot-scope="scope">
                  <el-select
                    @change="onInputHW(scope.$index)"
                    :disabled="disabledSee"
                    v-model="sendAddrs_1[scope.$index].heavyCargoConfDictId"
                    filterable
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item2, index2c) in heavyCargos"
                      :key="index2c"
                      :label="item2.val"
                      :value="item2.confDictId"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                v-if="false && !disabledSee"
              >
                <template slot-scope="scope">
                  <div class="iconList">
                    <i
                      v-if="scope.$index == 0"
                      class="el-icon-circle-plus iconSize"
                      @click="AddGoods(scope.$index)"
                    ></i>
                    <el-popconfirm
                      v-else
                      title="确定删除该行货物信息吗"
                      @confirm="delGoods(scope.$index)"
                    >
                      <i slot="reference" class="el-icon-remove iconSize"></i>
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 运输要求 -->
      <div class="infoDiv">
        <div class="h3title">运输要求</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form4"
            :rules="rule4"
            :model="transportInfo"
          >
            <el-form-item label="预计提货时间:">
              <el-date-picker
                :disabled="disabledSee"
                v-model="transportInfo.takeTime"
                value-format="yyyy-MM-dd  HH:mm:ss"
                default-time="23:59:59"
                type="datetime"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="预计送货时间:">
              <el-date-picker
                :disabled="disabledSee"
                v-model="transportInfo.deliveryTime"
                value-format="yyyy-MM-dd  HH:mm:ss"
                default-time="23:59:59"
                type="datetime"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="是否入仓:" class="double_item">
              <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="transportInfo.isIntoStorage"
                placeholder="请选择"
              >
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
              <el-input
                :disabled="disabledSee"
                class="second_ipt"
                v-model="transportInfo.intoStorageNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="收货仓号:">
              <el-input
                :disabled="disabledSee"
                v-model="transportInfo.receiveStorageNumber"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <div style="width: 100%; display: flex; align-items: center">
              <el-form-item label="特殊要求:">
                <el-select
                  :disabled="disabledSee"
                  clearable
                  filterable
                  remote
                  allow-create
                  default-first-option
                  v-model="transportInfo.specialRequire"
                  placeholder="请输入或选择"
                  @change="changeSpecialRequire()"
                >
                  <el-option
                    v-for="(item, index) in specialRequirements"
                    :key="index"
                    :label="item.val"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-checkbox
                v-model="transportInfo.isUrgent"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee"
                >加急</el-checkbox
              >
              <el-checkbox
                v-model="transportInfo.isWaitNoticeSend"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee"
                >等通知放货</el-checkbox
              >
              <el-checkbox
                v-model="transportInfo.isValuable"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee"
                >贵重</el-checkbox
              >
            </div>
          </el-form>
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form8"
            :rules="rule8"
            :model="transportInfo"
          >
            <div style="width: 100%; display: flex">
              <el-form-item
                label="是否投保:"
                class="double_item"
                prop="isInsure"
              >
                <el-select
                  :disabled="disabledSee"
                  filterable
                  clearable
                  v-model="transportInfo.isInsure"
                  placeholder="请选择"
                >
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="声明价值:"
                prop="declaredValue"
                :required="transportInfo.isInsure === 1"
              >
                <div style="position: relative">
                  <el-row>
                    <el-col :span="16"
                      ><el-input
                        :disabled="disabledSee"
                        v-model="transportInfo.declaredValue"
                        type="number"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input
                        :disabled="disabledSee"
                        v-model="transportInfo.declaredValueRate"
                        type="number"
                        placeholder="请输入"
                        suffix-icon=""
                      ></el-input>
                    </el-col> </el-row
                  ><span style="position: absolute; right: 2px; top: 0">‰</span>
                </div>
              </el-form-item>
            </div>
          </el-form>
          <!-- 运单图片 -->
          <div class="upload_pic" style="margin-bottom: 10px">
            <div
              style="
                margin-bottom: 10px;
                font-size: 13px;
                color: #303133;
                line-height: 1.769230769230769;
              "
            >
              上传图片: (支持上传jpg/png文件)
            </div>
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="9"
              :disabled="disabledSee"
            ></uploadimgs>
          </div>
        </div>
      </div>
      <!-- 财务相关 -->
      <div class="infoDiv" style="border-bottom: 1px solid #f59a23">
        <div class="h3title">财务相关</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form5"
            :rules="rule5"
            :model="financeInfo"
          >
            <el-form-item label="结算方式:" prop="settlementMethodConfDictId">
              <el-select
                :disabled="disabledSee"
                v-model="financeInfo.settlementMethodConfDictId"
                placeholder="请选择"
                clearable
                filterable
              >
                <el-option
                  v-for="item in settlementMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="代收货款:">
              <el-input
                :disabled="disabledSee"
                v-model="financeInfo.agentAmount"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      :showCacel="false"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1"
    >
      <div class="glo_dialogForm">
        <el-table :data="specifications_1" border style="width: 100%">
          <el-table-column label="*长" prop="length">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].length"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*宽" prop="wide">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].wide"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*高" prop="height">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].height"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*件数" prop="packageCout">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].packageCout"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" v-if="!disabledSee">
            <template slot-scope="scope">
              <div class="iconList">
                <i
                  v-if="specifications_1.length == scope.$index + 1"
                  class="el-icon-circle-plus iconSize"
                  @click="clickAdd"
                ></i>
                <el-popconfirm
                  v-if="specifications_1.length > 1"
                  title="确定删除该行规格吗"
                  @confirm="clickDel(scope.$index)"
                >
                  <i slot="reference" class="el-icon-remove iconSize"></i>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </myDialog>
    <!-- 弹窗 收件人地址 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3"
    >
      <div class="glo_dialogForm" ref="myDialogRef_as">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            v-if="isShowDialog3"
            :model="queryData"
            class="glo_form"
            label-position="left"
          >
            <el-form-item class="queryItems" label="联系人:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="联系电话:">
              <el-input
                clearable
                v-model="queryData.phone"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="单位/仓库:">
              <el-input
                clearable
                v-model="queryData.deptName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="getCustomerAddrList"
              >查询</el-button
            >
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table
            :height="TBHeight_as"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="changeAddress(scope.row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
        <!-- 分页 -->
        <paging
          :pageNum="pageStart_as"
          :total="pageCount_as"
          :size="pageTotal_as"
          @handleSizeChange="handleSizeChange_as"
          @handleCurrentChange="handleCurrentChange_as"
        ></paging>
      </div>
    </myDialog>
    <myDialog
      diaWidth="40%"
      dialogTitle="地址识别"
      :isShowDialog="isShowDialogAI"
      :showConfirm="true"
      @handleCloseDia="handleCloseDiaAI"
      @diaCancelBtn="handleCloseDiaAI"
      @diaConfirmBtn="diaConfirmBtnAI"
    >
      <el-card
        shadow="never"
        style="margin-bottom: 10px; border: 1px solid #cccccc"
        body-style="padding:0;"
      >
        <el-input
          type="textarea"
          class="address-ai-input"
          ref="addressAIInput"
          rows="6"
          v-model="addressAI.addressBefore"
        ></el-input>
        <div class="address-ai-button-container">
          <el-button type="primary" size="mini" @click="clearAddressAIText"
            >清空</el-button
          >
          <el-button type="primary" size="mini" @click="analysisAddress"
            >识别</el-button
          >
        </div>
      </el-card>
      <el-card
        shadow="never"
        style="border: 1px solid #cccccc"
        body-style="padding:8px;"
      >
        <el-form
          label-position="left"
          label-width="90px"
          class="address-ai-form"
        >
          <el-form-item label="姓名：">
            {{ addressAI.username }}
          </el-form-item>
          <el-form-item label="电话：">
            {{ addressAI.phone }}
          </el-form-item>
          <el-form-item label="省市区：">
            {{ addressAI.province }}-{{ addressAI.city }}-{{ addressAI.area }}
          </el-form-item>
          <el-form-item label="详细地址：">
            {{ addressAI.address }}
          </el-form-item>
        </el-form>
      </el-card>
    </myDialog>
    <myDialog
      diaWidth="1100px"
      dialogTitle="选择地址"
      :isShowDialog="isShowDialogMap"
      :dialogFooter="false"
      @handleCloseDia="handleCloseDiaMap"
      @diaCancelBtn="handleCloseDiaMap"
      @diaConfirmBtn="diaConfirmBtnMap"
      class="amp-map-dialog"
    >
      <AMPMAP @choose-it="chooseAddress" v-if="isShowDialogMap"></AMPMAP>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import _ from "lodash";
import { constants } from "os";
import paging from "@/components/pagings.vue"; //分页组件
import { Console } from "console";
import AMPMAP from "@/components/AMPMAP.vue";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    paging,
    uploadimgs,
    AMPMAP,
  },
  props: {
    commandId: {
      type: String,
      require: false,
      default() {
        return null;
      },
    },
    isSee: {},
  },
  data() {
    return {
      pageStart_as: 1, //  页码
      pageCount_as: 0, //  总条数
      pageTotal_as: this.$COMMON.pageTotals, //
      TBHeight_as: 500,
      saveKeys: "",
      //disabledSee: false,
      loadingDetail: false,
      volumeDivisor: "",
      commandInfo: {
        commandId: "",
        //	基础信息
        commandNumber: "",
        waybillNumber: "",
        transferNumber: "",
        customerOrderNumber: "",
        receiveOrderDeptId: this.$TOOLS.getUserInfo().departmentId || "",
        destCity: "",
        transportLineId: "",
        endDeptId: "",
        openOrderDeptId: this.$TOOLS.getUserInfo().departmentId || "",
        receiveMethodConfDictId: "",
        transportMethodConfDictId: "",
        sendMethodConfDictId: "",
        rnRequireConfDictId: "",
        rnRequireName: "",
        rnRequireCount: "",
        customerType: 0,
        customerId: "",
        customerName: "",
        remarks: "",
      },
      sendAddr: {
        addrId: "",
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        operationType: "UNCHANGED",
      },
      sendAddrs: [
        {
          itemId: "",
          serialNumber: "",
          goodsNumber: "",
          goodsName: "",
          itemCategoryCode: "",
          itemCategoryName: "",
          packageName: "",
          packageCout: "",
          grossWeight: "",
          netWeight: "",
          volumeWeight: "",
          weightVolume: "",
          billingWeight: "",
          volume: "",
          specs: "",
          volumeDivisor: "",
          heavyCargoConfDictId: "",
          operationType: "UNCHANGED",
          itemSpecsReqs: [
            {
              specsId: "",
              packageCout: "",
              length: "",
              wide: "",
              height: "",
              operationType: "UNCHANGED",
            },
          ],
          CategoryList: [],
        },
      ],
      sendAddrs_1: [],
      receiveAddr: {
        addrId: "",
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
      },
      takeAddr: {
        addrId: "",
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
      },
      transportInfo: {
        takeTime: "",
        deliveryTime: "",
        isIntoStorage: "",
        intoStorageNumber: "",
        receiveStorageNumber: "",
        specialRequireConfDictId: "",
        isUrgent: 0,
        isValuable: 0,
        isWaitNoticeSend: 0,
        isInsure: 0,
        declaredValue: "",
        declaredValueRate: "",
      },
      financeInfo: {
        settlementMethodConfDictId: "",
        agentAmount: "",
      },
      files: [
        {
          fileId: "",
          fileName: "",
        },
      ],

      isAutoAddr_sj: false,
      isAutoAddr_jj: false,
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      isAutoAddr_sj_1: false,
      cityNameList_1: [], //市
      areaNameList_1: [], //区

      cityNameList_2: [], //市
      areaNameList_2: [], //区

      CustomerLists: [], //客户列表
      addressNaemList: [], //客户档案列表
      OUTsendMethodList: [], //送货方式
      OUTTakeMethodList: [], //外发提货
      packageNameList: [], //货物信息
      car_type_list: [], //车型
      employeeList: [], // 开单接收人
      employeeList_1: [], //调度接收人
      storageList: [], //入仓仓库
      businessDepts: [],
      CarrierDeptListList: [], //网点
      changeCarrierList: [], //外发承运商
      goodsList: [],

      // 目的城市
      destCitys: [],
      destCityLoading: false,
      //线路
      lines: [],
      transportLineLoading: false,
      // 发货方式
      receMethods: [],
      transportMethods: [],
      sendMethods: [],
      rnRequirements: [],
      settlementMethods: [],
      specialRequirements: [],
      heavyCargos: [],
      // 地址弹窗
      isShowDialog3: false,
      isShowDialogAI: false,
      isShowDialogMap: false,
      addressAI: {
        addressType: "",
        addressText: "",
      },
      addressMap: {
        addressType: "",
      },
      dialogTitle3: "",
      diaWidth3: "80%",
      tableData: [],
      addressTableHeard: [
        {
          name: "单位",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系人",
          field: "personnelName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "身份证号",
          field: "idNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "详细地址",
          field: "address",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData: [], //收发地址 表格选择
      queryData: {
        //收发地址 查询条件
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      },

      //弹框 规格尺寸
      specIndex1: 0,
      isShowDialog1: false,
      dialogTitle1: "规格尺寸",
      diaWidth1: "60%",
      specifications: [
        {
          height: "",
          length: "",
          packageCout: "",
          wide: "",
          specsId: "",
          operationType: "UNCHANGED",
        },
      ], //规格尺寸 数据
      specifications_1: [],
      totalArr: [
        "packageCout",
        "grossWeight",
        "netWeight",
        "volume",
        "volumeWeight",
        "weightVolume",
        "billingWeight",
      ], //  表格需要合计的字段
      waybillStatus: "未开单",
      // 结算方式
      SettlementTypes: [
        "现付",
        "月结",
        "回单付",
        "到付现结",
        "到付月结",
        "多笔付",
        "免费",
        "货款扣",
      ],
      fileNameLists: [],
      rule1: {
        businessDate: [
          {
            required: true,
            message: "业务日期不能为空",
            trigger: "change",
          },
        ],
        receiveOrderDeptId: [
          {
            required: true,
            message: "开单网点不能为空",
            trigger: "change",
          },
        ],
      },
      // 基本信息校验规则
      rule2: {
        destCity: [
          {
            required: true,
            message: "目的城市不能为空",
            trigger: "change",
          },
        ],
        transportLineId: [
          {
            required: true,
            message: "线路不能为空",
            trigger: "change",
          },
        ],
        endDeptId: [
          {
            required: true,
            message: "终端网点不能为空",
            trigger: "change",
          },
        ],
        receiveMethodConfDictId: [
          {
            required: true,
            message: "发货方式不能为空",
            trigger: "change",
          },
        ],
        transportMethodConfDictId: [
          {
            required: true,
            message: "运输方式不能为空",
            trigger: "change",
          },
        ],
        sendMethodConfDictId: [
          {
            required: true,
            message: "交货方式不能为空",
            trigger: "change",
          },
        ],
        rnRequireCount: [
          {
            validator: (rule, value, callback) => {
              if (this.commandInfo.rnRequireConfDictId) {
                if (!value) {
                  callback(new Error("回单份数不能为空"));
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule4: {},
      rule5: {
        settlementMethodConfDictId: [
          {
            required: true,
            message: "结算方式不能为空",
            trigger: "change",
          },
        ],
      },
      rule7: {
        customerId: [
          {
            validator: (rule, value, callback) => {
              if (this.commandInfo.customerType) {
                if (!value) {
                  callback(new Error("客户不能为空"));
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule8: {
        isInsure: [
          {
            required: true,
            message: "是否投保不能为空",
            trigger: "change",
          },
        ],
        declaredValue: [
          {
            validator: (rule, value, callback) => {
              if (this.transportInfo.isInsure === 1) {
                if (!value) {
                  callback(new Error("必须填写声明价值"));
                }
              }
              callback();
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  // computed: {
  //   ""() {
  //     return "";
  //   },
  // },
  watch: {},
  created() {
    this.sendAddrs_1 = this.sendAddrs.filter(
      (item) => item.operationType != "DEL"
    );
    this.specifications_1 = this.specifications.filter(
      (item) => item.operationType != "DEL"
    );
  },
  computed: {
    editable() {
      return this.isSee != 1;
    },
    disabledSee() {
      return !this.editable;
    },
  },
  mounted() {
    // 根据字典类型获取字典值下拉列表
    this.getConfDictValDownList("package_name", "packageNameList"); //获取包装
    this.getConfDictValDownList("receive_method", "receMethods");
    this.getConfDictValDownList("transport_method", "transportMethods");
    this.getConfDictValDownList("send_method", "sendMethods");
    this.getConfDictValDownList("rn_order_require", "rnRequirements");
    this.getConfDictValDownList("settlement_method", "settlementMethods");
    this.getConfDictValDownList("special_order_require", "specialRequirements");
    this.getConfDictValDownList("heavy_cargo", "heavyCargos");
    //发货方式
    this.wtl_getItemList();

    // 获取接单网点
    this.getBusinessDepts();
    this.getDestCities();
    // 获取线路
    this.getTransportLine();

    // 城市信息
    this.getProvince();
    this.getCityName();
    this.getAreaName();
    this.remoteMethodCustomer();
  },
  activated() {
    if (!this.commandId) {
      return;
    }
    if (this.commandInfo.commandId == this.commandId) {
      return;
    }
    // this.getCommandInfo();
    // this.getCommandAddress();
    // this.getCommandGoods();
    // this.getTransportInfo();
    // this.getCommandFinance()
    this.getCommandDetail();
  },
  destroyed() {},
  methods: {
    // 获取物品品类
    wtl_getItemList(categoryName) {
      this.$API
        .goods({
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.goodsList = res || [];
        });
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    handleSizeChange_as(val) {
      //  分页
      this.pageTotal_as = val;
      this.getCustomerAddrList();
    },
    handleCurrentChange_as(val) {
      //  分页
      this.pageStart_as = val;
      this.getCustomerAddrList();
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.add(prev, curr);
                  // return this.$TOOLS.mathToFixed(
                  //   this.$TOOLS.add(prev, curr),
                  //   2
                  // );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable1.doLayout();
      });
      return sums;
    },

    // 接口获取详情
    async getCommandDetail() {
      //this.loadingDetail = true
      const res = await this.$API.getCommandDetail(this.commandId);
      this.commandInfo = res.commandInfo || {};
      this.financeInfo = res.financeInfo || {};
      this.receiveAddr = res.receiveAddr || {};
      this.waybillStatus = this.commandInfo.commandStatusShow;
      if (res.sendAddrs) {
        this.sendAddr = {
          ...res.sendAddrs[0],
          operationType: "UNCHANGED",
        };
        this.sendAddrs = res.sendAddrs[0].itemReqs;
        this.sendAddrs.forEach((item) => {
          item.operationType = "UNCHANGED";
          item.itemSpecsReqs.forEach((spec) => {
            spec.operationType = "UNCHANGED";
          });
        });
        this.sendAddrs_1 = this.sendAddrs.filter(
          (item) => item.operationType != "DEL"
        );
      } else {
        this.sendAddr = {};
        this.sendAddrs = [];
      }
      //this.sendAddrs = res.sendAddrs
      this.takeAddr = res.takeAddr || {};
      this.takeAddr.operationType = "UNCHANGED";
      this.transportInfo = res.transportInfo || {};
      if (res.files) {
        res.files.forEach((item) => {
          this.fileNameLists.push({
            name: item.fileId,
            url: item.fileUrl,
          });
        });
      }
      //this.loadingDetail = false
    },

    //  获取详情
    async getCommandInfo() {
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "commandId",
              conditonVal: this.commandId,
            },
          ],
          number: "admin_command_detail_v5",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas[0] || {};
            this.commandInfo = {
              //	基础信息
              commandId: datas.commandId,
              commandNumber: datas.commandNumber,
              waybillNumber: datas.waybillNumber,
              transferNumber: datas.transferNumber,
              customerOrderNumber: datas.customerOrderNumber,
              receiveOrderDeptId: datas.receiveOrderDeptId,
              destCity: datas.destCity,
              transportLineId: datas.transportLineId,
              endDeptId: datas.endDeptId,
              receiveMethodConfDictId: datas.receiveMethodConfDictId,
              transportMethodConfDictId: datas.transportMethodConfDictId,
              sendMethodConfDictId: datas.sendMethodConfDictId,
              rnRequireConfDictId: datas.rnRequireConfDictId,
              rnRequireName: datas.rnRequireName,
              rnRequireCount: datas.rnRequireCount,
              customerType: datas.customerType,
              customerId: datas.customerId,
              customerName: datas.customerName,
              remarks: datas.remarks,
            };
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },

    async getCommandAddress() {
      const res = await this.$API.runPageReportDetails({
        conditionReqs: [
          {
            conditonKey: "commandId",
            conditonVal: this.commandId,
          },
        ],
        number: "admin_command_detail_addr_v5",
      });
      const addresses = res.data.result.datas;
      const ji = addresses.filter(
        (item) => item.addressType === "ji:address_type"
      )[0];
      const shou = addresses.filter(
        (item) => item.addressType === "shou:address_type"
      )[0];
      const takes = addresses.filter(
        (item) => item.addressType === "self_take:address_type"
      );
      if (takes.length > 0) {
        const take = takes[0];
        this.takeAddr = {
          ...take,
        };
      }
      this.sendAddr = {
        ...ji,
      };
      this.receiveAddr = {
        ...shou,
      };
    },

    async getCommandGoods() {
      const res = await this.$API.runPageReportDetails({
        conditionReqs: [
          {
            conditonKey: "commandId",
            conditonVal: this.commandId,
          },
        ],
        number: "admin_command_detail_item_v5",
      });
    },

    async getTransportInfo() {
      const res = await this.$API.runPageReportDetails({
        conditionReqs: [
          {
            conditonKey: "commandId",
            conditonVal: this.commandId,
          },
        ],
        number: "admin_command_detail_transport_v5",
      });
      const transportInfo = res.data.result.datas[0];
      this.transportInfo = {
        ...transportInfo,
      };
    },
    async getCommandFinance() {
      const res = await this.$API.runPageReportDetails({
        conditionReqs: [
          {
            conditonKey: "commandId",
            conditonVal: this.commandId,
          },
        ],
        number: "admin_command_detail_fianceinfo_v5",
      });
      const financeInfo = res.data.result.datas[0];
      this.financeInfo = {
        ...financeInfo,
      };
    },

    runPageReportDetailsitemId(conditonVal, i) {
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "itemId",
              conditonVal,
            },
          ],
          number: "command_item_specs_list",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            datas.forEach((n, i) => {
              n.operationType = "UNCHANGED";
            });
            this.takeAddr[i].itemSpecsReqs = datas;
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },

    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    //员工、部门、外发网点
    changeMethod(e, arrs, keys) {
      let curs = this[arrs].filter((item) => item.documentId == e);
      if (keys == "intoDeptName") {
        this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
      } else {
        this.commandInfo[keys] = (curs.length && curs[0].name) || "";
      }
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
          console.log(this[keys]);
        });
    },

    //外发承运商
    focusMethodCarrier() {
      if (this.changeCarrierList.length == 0) {
        this.remoteMethodCarrier("");
      }
    },
    //外发承运商
    changeMethodCarrier(e) {
      let curs = this.changeCarrierList.filter((item) => item.carrierId == e);
      this.financeInfo.carrierName = (curs.length && curs[0].carrierName) || "";
      if (e) {
        // 获取承运商——网点
        this.$COMAPI.CarrierDeptList(e).then((res) => {
          this.CarrierDeptListList = res || [];
        });
      }
    },
    //外发承运商 carrierId carrierName
    remoteMethodCarrier(carrierName) {
      this.$API
        .CarrierList({
          carrierName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.changeCarrierList = res.data.result.data || [];
        });
    },

    //品类
    focusMethodCategory(index) {
      // if (this.sendAddrs[index].CategoryList.length == 0) {
      //   this.remoteMethodCategory("", index);
      // }
    },
    //品类
    changeMethodCategory(e, index) {
      this.sendAddrs_1[index].operationType = "UPDATE";
      let curs = this.sendAddrs_1[index].CategoryList.filter(
        (item) => item.itemCategoryName == e
      );
      this.sendAddrs_1[index].itemCategoryCode =
        (curs.length && curs[0].itemCategoryCode) || "";
      console.log(this.sendAddrs_1[index].itemCategoryCode);
    },
    //品类
    remoteMethodCategory(categoryName, index) {
      this.$API
        .wtl_getCategoryList({
          categoryName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.sendAddrs_1[index].CategoryList = res.data.result.data || [];
        });
    },

    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
    },

    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },

    //货物信息 添加一行货物信息
    AddGoods(idx) {
      let objs = {
        itemId: "",
        serialNumber: "",
        goodsNumber: "",
        goodsName: "",
        itemCategoryCode: "",
        itemCategoryName: "",
        packageName: "",
        packageCout: "",
        grossWeight: "",
        netWeight: "",
        volumeWeight: "",
        weightVolume: "",
        billingWeight: "",
        volumeDivisor: this.volumeDivisor,
        volume: "",
        specs: "",
        heavyCargoConfDictId: "",
        operationType: "ADD",
        itemSpecsReqs: [
          {
            specsId: "",
            packageCout: "",
            length: "",
            wide: "",
            height: "",
            operationType: "ADD",
          },
        ],
        CategoryList: [],
      };
      if (this.saveKeys == 2 && this.commandId) {
        objs.operationType = "ADD";
      }
      this.sendAddrs.push(objs);
      this.sendAddrs_1 = this.sendAddrs.filter(
        (item) => item.operationType != "DEL"
      );
    },
    //货物信息 删除一行货物信息
    delGoods(idx) {
      this.sendAddrs_1[idx].operationType = "DEL";
      this.sendAddrs_1 = this.sendAddrs.filter(
        (item) => item.operationType != "DEL"
      );
    },
    onInputHW(index) {
      this.sendAddrs_1[index].operationType = "UPDATE";
    },
    //设置规格
    clickSet(index) {
      this.specIndex1 = index;
      this.sendAddrs[index].operationType = "UPDATE";
      this.specifications = this.sendAddrs[index].itemSpecsReqs || [];
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
      this.isShowDialog1 = true;
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
    },
    //设置规格  确认保存
    diaConfirmBtn1() {
      this.sendAddrs[this.specIndex1].itemSpecsReqs = this.specifications;
      this.isShowDialog1 = false;
    },

    //设置规格 添加规格
    clickAdd() {
      this.specifications.push({
        specsId: "",
        height: "",
        length: "",
        packageCout: "",
        wide: "",
        operationType: "ADD",
      });
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
    },
    //设置规格 删除一行规格
    clickDel(index) {
      this.specifications_1[index].operationType = "DEL";
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
    },
    onInput(index) {
      this.specifications_1[index].operationType = "UPDATE";
    },

    //客户
    async remoteMethodCustomer(customerName) {
      const res = await this.$API.runList({
        keyword: customerName,
        pageStart: 1,
        pageTotal: 20,
        approveStatus: "tong_guo:approve_status",
        number: "customer_down_list",
      });
      this.CustomerLists = res || [];
    },
    changeCustomerType() {
      if (this.commandInfo.customerType == 0) {
        this.commandInfo.customerId = null;
        this.commandInfo.customerName = "";
      }
    },
    //客户
    focusMethodCustomer() {
      if (this.CustomerLists.length == 0) {
        this.remoteMethodCustomer("");
      }
    },
    //客户  选择或者清除客户时触发
    changeMethodCustomer(e) {
      let curs = this.CustomerLists.filter((item) => item.customerId == e);
      let customerName = (curs.length && curs[0].customerName) || "";
      this.commandInfo.customerName = customerName;
      if (e) {
        this.getCustomerDefaultAddrList(e);
        // 设置结算方式
        const cur = curs[0];
        this.transportInfo.settlementMethodConfDictId = parseInt(
          cur.settlementMethodConfDictId
        );
        this.transportInfo.isInsure = cur.isSure;
        this.transportInfo.declaredValueRate = cur.insuranceRate;
      }
    },
    //客户 根据客户id获取客户默认地址
    getCustomerDefaultAddrList(id) {
      this.$API
        .runList({
          customerId: id,
          number: "customer_default_address_map",
        })
        .then((res) => {
          let datas = res || [];
          if (datas.length > 0) {
            let jjAddressData = {}; // 寄件默认地址;
            let sjAddressData = {}; // 收件默认地址;
            datas.forEach((item) => {
              if (item.addressType == "ji_jian:address_type") {
                jjAddressData = item;
              }
              if (item.addressType == "shou_jian:address_type") {
                sjAddressData = item;
              }
            });
            if (jjAddressData) {
              jjAddressData.contacts =
                jjAddressData.companyName || jjAddressData.deptName;
              jjAddressData.company = jjAddressData.deptName;
              jjAddressData.tel = jjAddressData.tel || jjAddressData.phone;
              jjAddressData.addrId = "";
              this.sendAddr = JSON.parse(JSON.stringify(jjAddressData));
            } else {
              this.sendAddr = {};
            }
            if (sjAddressData) {
              sjAddressData.contacts = sjAddressData.contactsName || "";
              sjAddressData.company =
                sjAddressData.companyName || sjAddressData.deptName;
              sjAddressData.tel = sjAddressData.tel || sjAddressData.phone;
              sjAddressData.addrId = "";
              this.receiveAddr = JSON.parse(JSON.stringify(sjAddressData));
            } else {
              this.receiveAddr = {};
            }
          } else {
            this.sendAddr = {};
            this.receiveAddr = {};
          }
        });
    },

    // 发货地址 自动识别地址
    geocode(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.sendAddrs));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.sendAddrs = sj;
      });
    },
    // 收货地址 自动识别地址
    geocode_1(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.receiveAddr));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.receiveAddr = sj;
      });
    },
    async getDestCities(keyword) {
      this.destCityLoading = true;
      const data = await this.$API.runList({
        number: "admin_dest_city_downlist",
        keyword,
      });
      this.destCitys = data;
      this.destCityLoading = false;
    },
    async clearDestCity() {
      this.getDestCities();
    },
    changeDestCity() {
      this.getTransportLine();
    },
    async getTransportLine() {
      this.transportLineLoading = true;
      const data = await this.$API.runList({
        number: "down_list_transport_line_v4",
        city: this.commandInfo.destCity,
      });
      this.lines = data;
      this.transportLineLoading = false;
      if (this.lines.length > 0 && this.commandInfo.destCity) {
        this.commandInfo.transportLineId = this.lines[0].id;
        this.volumeDivisor = this.lines[0].volumeDivisor;
        this.commandInfo.endDeptId = this.lines[0].arriveDeptId;
        this.changeEndDept();
        if (this.sendAddrs.length > 0) {
          for (let sendAddr of this.sendAddrs) {
            if (!sendAddr.volumeDivisor) {
              sendAddr.volumeDivisor = this.volumeDivisor;
            }
          }
        }
      }
    },
    changeTransportLine() {
      const line = this.lines.filter(
        (d) => d.id == this.commandInfo.transportLineId
      )[0];
      this.volumeDivisor = line.volumeDivisor;
      this.commandInfo.endDeptId = line.arriveDeptId;
      this.changeEndDept();
      if (this.sendAddrs.length > 0) {
        for (let sendAddr of this.sendAddrs) {
          console.log(this.volumeDivisor);
          if (!sendAddr.volumeDivisor) {
            sendAddr.volumeDivisor = this.volumeDivisor;
          }
        }
      }
    },
    changeEndDept() {
      this.changeSendMethod();
    },
    changeOpenDept(id, item) {},
    changeSendMethod() {
      const sendMethods = this.sendMethods.filter(
        (item) => item.id === this.commandInfo.sendMethodConfDictId
      );
      if (sendMethods.length == 0) {
        return;
      }
      const sendMethod = sendMethods[0];
      if (sendMethod.key !== "客户自提") {
        return;
      }
      const depts = this.businessDepts.filter(
        (item) => item.deptId === this.commandInfo.endDeptId
      );
      if (depts.length === 0) {
        return;
      }
      const dept = depts[0];
      // 设置自提默认
      this.takeAddr = {
        addrId: this.takeAddr.addrId,
        serialNumber: "1",
        contacts: dept.chargePersonName,
        company: dept.deptName,
        tel: dept.takeGoodsTel,
        provinceName: dept.provinceName,
        cityName: dept.cityName,
        areaName: dept.areaName,
        address: dept.address,
        operationType: this.takeAddr.addrId ? "UPDATE" : "ADD",
      };
    },
    // 默认查省级
    getProvince(e) {
      this.$API
        .district({
          parentId: 1,
        })
        .then((res) => {
          this.SuperiorRegionList = res || [];
        });
    },
    // 获取市 (收货地址)
    getCityName(e, type) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          const fieldName = "cityNameList" + (type ? "_" + type : "");
          this[fieldName] = data;
        });
    },
    // 获取市 (收货地址)
    getAreaName(e, type) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          const fieldName = "areaNameList" + (type ? "_" + type : "");
          this[fieldName] = data;
        });
    },
    // 选择省(收货地址)
    changeProvince(type) {
      let obj = this.sendAddr;
      if (type === 1) {
        obj = this.receiveAddr;
      }
      if (type === 2) {
        obj = this.takeAddr;
      }
      obj.cityName = "";
      obj.areaName = "";
      if (type) {
        this.cityNameList = [];
        this.areaNameList = [];
      } else {
        this["cityNameList_" + type] = [];
        this["areaNameList_" + type] = [];
      }
      const provinceName = obj.provinceName;
      if (provinceName) {
        this.getCityName(provinceName, type);
      }
    },
    // 选择市(收货)
    changeCity(type) {
      let obj = this.sendAddr;
      if (type === 1) {
        obj = this.receiveAddr;
      }
      if (type === 2) {
        obj = this.takeAddr;
      }
      obj.areaName = "";
      if (type) {
        this.areaNameList = [];
      } else {
        this["areaNameList_" + type] = [];
      }
      const cityName = obj.cityName;
      if (cityName) {
        this.getAreaName(cityName, type);
      }
    },
    changeArea(e) {
      this.$forceUpdate();
    },
    //收发货地址
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      };
    },
    handleCloseDiaAI() {
      this.isShowDialogAI = false;
    },
    handleCloseDiaMap() {
      this.isShowDialogMap = false;
    },
    diaConfirmBtnMap() {},
    //收发货地址  弹窗确认保存事件
    diaConfirmBtn3() {
      // 添加费项
      this.isShowDialog3 = false;
    },

    diaConfirmBtnAI() {
      this.isShowDialogAI = false;
      // 回填地址
      const address = {
        companyName: "",
        personnelName: this.addressAI.username,
        tel: this.addressAI.phone,
        provinceName: this.addressAI.province,
        cityName: this.addressAI.city,
        areaName: this.addressAI.area,
        address: this.addressAI.address,
        idNumber: this.addressAI.idNumber,
        addressType: this.addressAI.addressType,
      };
      this.changeAddress(address);
    },
    changeRnRquireConf() {
      const rnQuirement = this.rnRequirements.filter(
        (item) => item.id == this.commandInfo.rnRequireConfDictId
      )[0];
      this.commandInfo.rnRequireName = rnQuirement.val;
    },
    //收发货地址  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn3() {
      this.isShowDialog3 = false;
    },
    //收发货地址 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    //收发货地址 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //收发货地址 选择收件人地址
    changeRecAddress(type) {
      if (type == 1) {
        this.dialogTitle3 = "选择发货地址";
        this.queryData.addressType = "ji_jian:address_type";
      } else {
        this.dialogTitle3 = "选择收货地址";
        this.queryData.addressType = "shou_jian:address_type";
      }
      this.queryData.customerId = this.commandInfo.customerId || "";
      if (this.commandInfo.customerId) {
        this.isShowDialog3 = true;
        this.getCustomerListAddress();
        this.getCustomerAddrList();
      } else {
        if (this.commandInfo.customerName) {
          this.$message.warning("当前客户没有客户档案").showClose = true;
        } else {
          this.$message.warning("请先选择客户").showClose = true;
        }

        return false;
      }
    },
    changeSpecialRequire() {
      const selectedSpecialRequirements = this.specialRequirements.filter(
        (item) => item.val === this.transportInfo.specialRequire
      );
      if (selectedSpecialRequirements.length > 0) {
        this.transportInfo.specialRequireConfDictId =
          selectedSpecialRequirements[0].id;
      }
    },
    //收发货地址 选择地址
    //收发货地址 选择地址
    changeAddress(row, ignorePersonInfo = false) {
      if (
        this.queryData.addressType == "ji_jian:address_type" ||
        row.addressType === "ji_jian:address_type"
      ) {
        //寄件
        if (!ignorePersonInfo) {
          this.sendAddr.company = row.companyName || row.deptName;
          this.sendAddr.contacts = row.personnelName || "";
          this.sendAddr.tel = row.tel || "";
          this.sendAddr.idNumber = row.idNumber || "";
        }
        this.sendAddr.provinceName = row.provinceName || "";
        this.sendAddr.cityName = row.cityName || "";
        this.sendAddr.areaName = row.areaName || "";
        this.sendAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName);
        this.getAreaName(row.cityName);
      } else if (
        this.queryData.addressType == "shou_jian:address_type" ||
        row.addressType === "shou_jian:address_type"
      ) {
        //收件
        if (!ignorePersonInfo) {
          this.receiveAddr.company = row.companyName || row.deptName;
          this.receiveAddr.contacts = row.personnelName || "";
          this.receiveAddr.tel = row.tel || "";
          this.receiveAddr.idNumber = row.idNumber || "";
        }
        this.receiveAddr.provinceName = row.provinceName || "";
        this.receiveAddr.cityName = row.cityName || "";
        this.receiveAddr.areaName = row.areaName || "";
        this.receiveAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName, 1);
        this.getAreaName(row.cityName, 1);
      } else {
        // 自提
        if (!ignorePersonInfo) {
          this.takeAddr.company = row.companyName || row.deptName;
          this.takeAddr.contacts = row.personnelName || "";
          this.takeAddr.tel = row.tel || "";
          this.takeAddr.idNumber = row.idNumber || "";
        }
        this.takeAddr.provinceName = row.provinceName || "";
        this.takeAddr.cityName = row.cityName || "";
        this.takeAddr.areaName = row.areaName || "";
        this.takeAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName, 2);
        this.getAreaName(row.cityName, 2);
      }
    },
    //收发货地址 获取客户档案列表()
    getCustomerListAddress(name) {
      this.$API
        .wtl_getCustomerList({
          customerName: name || "",
          approveStatus: "tong_guo:approve_status", //审核通过
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.addressNaemList = res.data.result.data || [];
        });
    },
    //收发货地址 收-发货人列表
    getCustomerAddrList() {
      this.$API
        .wtl_getCustomerAddrList({
          customerId: this.queryData.customerId,
          addressType: this.queryData.addressType,
          deptName: this.queryData.deptName,
          personnelName: this.queryData.personnelName,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
          this.pageCount_as = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            let Heigth = this.$refs.myDialogRef_as.offsetHeight || 0; //弹窗的高度
            this.TBHeight_as = Heigth * 1 - 51 - 54 - 40;
          });
        });
    },

    // 收录客户地址
    autoAddCustomerAddrApi(datas) {
      return this.$API
        .autoAddCustomerAddr({
          address: datas.address || "",
          addressType: datas.addressType || "",
          cityName: datas.cityName || "",
          contacts: datas.contacts || "",
          customerId: datas.customerId || "",
          provinceName: datas.provinceName || "",
          tel: datas.tel || "",
          addressName: datas.addressName || "",
          areaName: datas.areaName || "",
          phone: datas.tel || "",
          remarks: datas.remarks || "",
          deptName: datas.deptName || "",
        })
        .then((res) => {});
    },
    saveClick(key) {
      //新增
      this.saveKeys = key;
      this.disabledSee = false;
      // switch (key) {
      //   case 1:

      //     break;
      //   case 2:
      //     break;
      //   case 3:
      //     break;
      // }
    },
    async check() {
      const forms = [1, 2, 4, 5, 7, 8];
      const promise = forms.map(async (i) => {
        let form = this.$refs["form" + i];
        if (!form) {
          return true;
        }
        const validate = form.validate();
        if (!validate) {
          return true;
        }
        const pro = await validate
          .then((res) => {
            return true;
          })
          .catch((err) => {
            return false;
          });
        return pro;
      });
      const result = await Promise.all(promise);
      const valid = result.filter((item) => !item).length === 0;
      if (!valid) {
        this.$message.warning("请完善信息");
      }
      return valid;
    },
    // 提交
    async submit() {
      const this_ = this;
      const check = await this.check();
      if (!check) {
        return;
      }
      const files = [];
      this.fileNameLists.forEach((file) => {
        files.push({
          fileId: file.name,
          fileName: file.name,
        });
      });
      let params = {
        commandInfo: this.commandInfo,
        sendAddrs: [
          {
            ...this.sendAddr,
            itemReqs: this.sendAddrs,
            operationType: this.sendAddr.operationType || "UPDATE",
          },
        ],
        receiveAddr: this.receiveAddr,
        takeAddr: this.takeAddr,
        transportInfo: this.transportInfo,
        financeInfo: this.financeInfo,
        files,
      };
      this.preProcess(params);
      if (this.commandId) {
        params.commandInfo.commandId = this.commandId;
        this.$API.commandupdateCommand(params).then((res) => {
          this.$message.success(res.data.message || "修改成功");
          this.reset();
        });
      } else {
        await this.$API.commandaddCommand(params).then((res) => {
          if (this_.commandInfo.customerId) {
            this.autoSaveAddress();
          }
          this.$confirm("新建成功 ", "提示：", {
            confirmButtonText: "查看列表",
            cancelButtonText: "继续新建",
          })
            .then(() => {
              this_.$message.success(res.data.message || "新增成功");
              this.reset();
              this.toList();
            })
            .catch(() => {
              this.reset();
            });
        });
      }
    },
    preProcess(params) {
      if (params.commandInfo.customerId === "") {
        params.commandInfo.customerId = null;
      }
      let financeInInfo = params.financeInfo;
      if (financeInInfo) {
        financeInInfo.agentAmount = this.dealZeroWhileEmpty(
          financeInInfo.agentAmount
        );
      }
      let transportInfo = params.transportInfo;
      if (transportInfo) {
        transportInfo.declaredValue = this.dealZeroWhileEmpty(
          transportInfo.declaredValue
        );
        transportInfo.declaredValueRate = this.dealZeroWhileEmpty(
          transportInfo.declaredValueRate
        );
      }
    },
    autoSaveAddress() {
      const this_ = this;
      if (this_.isAutoAddr_jj) {
        // 自动收录收件地址
        this_.autoAddCustomerAddrApi({
          customerId: this_.commandInfo.customerId || "",
          addressType: "ji_jian:address_type",
          address: this_.sendAddr.address || "",
          cityName: this_.sendAddr.cityName || "",
          contacts: this_.sendAddr.contacts || "",
          provinceName: this_.sendAddr.provinceName || "",
          tel: this_.sendAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.sendAddr.areaName || "",
          phone: this_.sendAddr.tel || "",
          deptName:
            this_.sendAddr.company ||
            this.sendAddr.sendAddr.companyName ||
            this.sendAddr.deptName,
          idNumber: this.sendAddr.idNumber,
          remarks: "",
        });
      }
      if (this_.isAutoAddr_sj) {
        // 自动收录收件地址
        this_.autoAddCustomerAddrApi({
          customerId: this_.commandInfo.customerId || "",
          addressType: "shou_jian:address_type",
          address: this_.receiveAddr.address || "",
          cityName: this_.receiveAddr.cityName || "",
          contacts: this_.receiveAddr.contacts || "",
          provinceName: this_.receiveAddr.provinceName || "",
          tel: this_.receiveAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.receiveAddr.areaName || "",
          phone: this_.receiveAddr.tel || "",
          deptName:
            this_.receiveAddr.company ||
            this.receiveAddr.companyName ||
            this.receiveAddr.deptName,
          idNumber: this.receiveAddr.idNumber,
          remarks: "",
        });
      }
    },
    // 重置页面
    toList() {
      //this.$TOOLS.closePage();
      this.$BaseIndex.closeCurrentTab(
        "/WaybillManage/NewPickupInstructionList"
      );
    },
    reset() {
      this.$emit("reset");
    },
    calcVolumeWeight(pos) {
      let sendAddr = {};
      const { volume, ratio } = (sendAddr = this.sendAddrs[pos]);
      console.log(volume, ratio);
      if (volume && ratio) {
        sendAddr.volumeWeight = volume * ratio;
      }
    },
    go2AddressAI(type) {
      this.isShowDialogAI = true;
      if (type == 1) {
        this.addressAI.addressType = "ji_jian:address_type";
      } else {
        this.addressAI.addressType = "shou_jian:address_type";
      }
    },
    go2Map(type) {
      this.isShowDialogMap = true;
      if (type == 1) {
        this.addressMap.addressType = "ji_jian:address_type";
      } else if (type == 2) {
        this.addressMap.addressType = "shou_jian:address_type";
      } else {
        this.addressMap.addressType = "self_take:address_type";
      }
    },
    chooseAddress(options) {
      this.isShowDialogMap = false;
      // 回填地址
      const address = {
        provinceName: options.province,
        cityName: options.city,
        areaName: options.district,
        address: options.address,
        addressType: this.addressMap.addressType,
      };
      this.changeAddress(address, true);
    },
    go2AddressBook(type) {
      this.isShowDialog3 = true;
    },
    clearAddressAIText() {
      this.$refs.addressAIInput.innerHTML = "";
    },
    analysisAddress() {
      const text = this.$refs.addressAIInput.innerHTML;
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.form_head {
  .waybill_Type {
    margin-bottom: 10px;
    width: fit-content;
    color: #ff0000;
    font-weight: bold;
    border: 2px dashed transparent;
    border-radius: 5px;
    padding: 2px 12px;
    background: linear-gradient(#fff, #fff) padding-box,
      repeating-linear-gradient(
        -75deg,
        #ff0000 0,
        #ff0000 0.9em,
        #fff 0,
        #fff 1.2em
      );
  }
  .head_formBox {
    justify-content: space-between;
    .el-form-item {
      margin-bottom: 20px;
      width: 18%;
      min-width: unset;
      margin-right: unset;
      overflow: unset;
    }
  }
}
.all_div {
  border: 1px solid #f59a23;
}

.infoDiv {
  border-width: 1px 1px 0 1px;
  border-style: solid;
  border-color: #f59a23;
  display: flex;
  .h3title {
    background: #f9c99d;
    margin: 0;
    color: #fff;
    width: 40px;
    font-size: 18px;
    display: flex;
    align-items: center;
    // background-color: #f2f2f2;
    padding: 5px;
    // padding: 10px;
    // border-bottom: 1px solid @borderColor;
    font-weight: bold;
    // margin-bottom: 20px;
  }

  .formbox {
    // padding: 0 30px;
    padding: 0 10px;
    width: calc(100% - 70px);
    .glo_formBox {
      .double_item {
        /deep/.el-form-item__content {
          display: flex;
          .el-select {
            input {
              //padding-left: 5px;
            }
          }
          .second_ipt {
            input {
              padding-left: 5px;
              padding-right: 10px;
            }
          }
          .unit {
            margin-right: 5px;
          }
        }
      }
      .Divider {
        width: 100%;
        height: 1px;
        margin-bottom: 10px;
        border-top: 1px dashed transparent;
        background: linear-gradient(#fff, #fff) padding-box,
          repeating-linear-gradient(
            -75deg,
            #797979 0,
            #797979 0.9em,
            #fff 0,
            #fff 1.2em
          );
      }
    }
    .head_formBox {
      justify-content: flex-start;
      margin: 15px 0 5px 0;
      .el-form-item {
        margin-bottom: 20px;
        overflow: unset;
        // width: 18%;
        width: calc(24% - 2px);
        min-width: unset;
      }
    }
    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin: 10px 0;
    // margin-top: 30px;
    // border-bottom: 4px solid #ccc;
    // padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table {
    width: 100%;
    .cell {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
.linkTabel {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 45px 10px 30px;
}
.address-ai-input {
  height: 80px;
  padding: 8px;
  &:focus-visible {
    outline: none;
  }
}
.address-ai-button-container {
  text-align: right;
  padding: 5px 8px 5px 5px;
}
.address-ai-form {
  .el-form-item {
    margin-bottom: 1px;
    ::v-deep .el-form-item__label {
      text-align: right;
    }
  }
}
</style>
